import { Activity, MonitorSmartphone, Siren, Zap } from 'lucide-react'
import { useQuery } from '@tanstack/react-query'
import { getRealtimeStats } from '../../../api/stats'
import { QueryBoundary } from '../../../components/common/QueryBoundary'
import { StatCard } from '../../../components/common/StatCard'
import { Skeleton } from '../../../components/ui/skeleton'

export function StatsGrid() {
  const query = useQuery({
    queryKey: ['stats', 'realtime'],
    queryFn: getRealtimeStats,
    refetchInterval: 30_000,
    retry: 1,
  })

  return (
    <QueryBoundary
      query={query}
      skeleton={
        <div className="grid grid-cols-2 gap-3">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} className="h-[86px] rounded-xl" />
          ))}
        </div>
      }
      isEmpty={(d) => d.onlineDevices === 0 && d.totalDevices === 0}
      empty={{ title: '无设备接入', description: '等待终端心跳上报，或检查后端服务状态' }}
      className="grid grid-cols-2 gap-3"
    >
      {(stats) => (
        <>
          <StatCard label="在线设备" value={stats.onlineDevices} hint={`共 ${stats.totalDevices}`} icon={MonitorSmartphone} tone="primary" />
          <StatCard label="今日触发" value={stats.todayTriggers} hint="终端 STA/LTA 触发" icon={Zap} tone="warning" />
          <StatCard label="本月地震" value={stats.monthEarthquakes} hint="确认事件" icon={Siren} tone="critical" />
          <StatCard label="在线率" value={`${stats.totalDevices > 0 ? Math.round((stats.onlineDevices / stats.totalDevices) * 100) : 0}%`} icon={Activity} />
        </>
      )}
    </QueryBoundary>
  )
}
